import { tw } from 'utils/classnames'
import { Link } from '@repo/web-ui/components/link'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { rootPath } from '@repo/web-utils/root-path'
import { LFS_URL } from '@web/utils/env'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

const relativePath = AppRoutes.EMBROIDERY.replace(rootPath, '')
interface ImageBannerProps {
  className?: string
}

export function ImageBanner({ className }: ImageBannerProps) {
  const t = useTranslations('pages.embroidery.cards')

  return (
    <div
      className={tw('rounded-2 relative z-0 h-[278px] w-full overflow-hidden md:mb-4', className)}
    >
      <div
        className={tw(
          'relative rounded-2 h-[45px] w-1/3 object-cover object-top md:absolute md:bottom-0 md:z-0 md:h-full md:w-full',
        )}
      >
        <Image
          src={`${LFS_URL}/web/pages/legacy-product-pages/embroidery/embroidery-secondary-mobile-1x.webp`}
          alt="Embroidery Crafts"
          fill
          priority
          unoptimized
          sizes="33vw"
          className="h-full w-full rounded-2 object-cover object-top md:hidden"
        />
        <Image
          src={`${LFS_URL}/web/pages/legacy-product-pages/embroidery/embroidery-secondary-2x.webp`}
          alt="Embroidery Crafts"
          fill
          priority
          unoptimized
          sizes="100vw"
          className="hidden h-full w-full rounded-2 object-cover object-top md:block"
        />
      </div>
      <div className="text-cf-white bottom-0 z-10 flex w-full flex-row justify-between md:absolute md:px-10 md:py-5">
        <div className="hidden font-bold uppercase md:block">{t('info')}</div>
        <Link href={`${relativePath}embroidery-designs/page/1/`} className="w-full md:w-auto">
          <span className="bg-primary-500 rounded-2 inline-block w-full text-center font-bold uppercase leading-[45px] md:hidden md:bg-transparent md:text-left md:leading-[auto]">
            {t('info')}
          </span>
          <div className="hidden underline md:block">{t('view_all') + ' >'}</div>
        </Link>
      </div>
    </div>
  )
}
